import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ProjectCAPS = () => {
  return (
    <section className="projectCAPS py-5">
      <Container fluid="lg">
        <Row className="justify-content-center">
          <Col md={10} lg={8} className="text-center">
            <div className="projectCAPS__box p-4 p-md-5">
              <h2 className="projectCAPS__title">
                Proyecto «Salud para disfrutar sin límite de edad»
              </h2>

              <div className="mt-4">
                <a
                  href="https://capsmujeresysalud.org/proyecto-salud-para-disfrutar-sin-limite-de-edad/"
                  className="projectCAPS__button main_btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  QUIERO VER
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProjectCAPS;